import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { DeviceLostOption, UserAsset } from '@models/dashboard.model';
import { ShoppingCartData } from '@models/shopping-cart.model';
import { TranslationPipe } from '@pipes/translation/translation.pipe';
import { ModalService } from '@services/modal/modal.service';
import { TranslationService } from '@services/translation/translation.service';

@Component({
  selector: 'ts-preserve-plans-features',
  templateUrl: './preserve-plans-features.component.html',
  imports: [CommonModule, ReactiveFormsModule, TranslationPipe]
})
export class PreservePlansFeaturesComponent implements OnInit {
  @Input() shopping_cart: ShoppingCartData;
  @Input() active_asset: UserAsset;
  @Output() selectKeepPlan: EventEmitter<boolean> = new EventEmitter<boolean>();
  device_upgrade_options: DeviceLostOption[];
  upgrade_form: FormGroup;

  constructor(private modal_svc: ModalService, private translation_svc: TranslationService) {}

  ngOnInit() {
    this.device_upgrade_options = this.translation_svc.getTranslatedDeviceUpgradeOptions();
    this.populateForm();
  }

  continueToUpgrade(): void {
    this.selectKeepPlan.emit(this.upgrade_form.value.upgradeOptions === 1 ? true : false);
  }

  dismissModal(): void {
    this.modal_svc.dismissAll();
  }

  private populateForm(): void {
    this.upgrade_form = new FormGroup({
      upgradeOptions: new FormControl(null, [Validators.required])
    });
  }
}
